/**
 * Where a docs page and its machine copies live — one home for the URL rules the build writes by
 * and the site reads by (design §0.2 "URL ve makine yüzeyleri", §0.9).
 */
import { DOCS_BASE, DOCS_DATA_DIR, PAGE_REFS } from "../nav";

/** A docs-root path ("/task-apis/limits") → its site URL ("/task-apis/limits"; "/docs/…" under a base). */
export const siteUrl = (path: string): string => `${DOCS_BASE}${path === "/" ? "" : path}` || "/";

/**
 * Where an error code is explained: its anchor on the Errors page, which the build prints from the
 * live catalogue (`::error-codes`) — the one address the task pages and the Developers panel's Errors
 * screen both link to. A docs-root path; `siteUrl` makes it a site URL.
 */
export const errorCodePath = (code: string, errorsPage: string = PAGE_REFS.errorCodes): string => `${errorsPage}#${code}`;

/** The page's Markdown twin (design §0.9: every page has a `.md` copy). */
export const markdownUrl = (path: string): string => `${DOCS_BASE}${path === "/" ? "/index" : path}.md`;

/** The page's data file, written by the build. */
export const pageDataUrl = (path: string): string => `${DOCS_BASE}/${DOCS_DATA_DIR}/pages${path === "/" ? "/index" : path}.json`;

export const siteDataUrl = (): string => `${DOCS_BASE}/${DOCS_DATA_DIR}/site.json`;

export const LLMS_TXT = `${DOCS_BASE}/llms.txt`;
export const LLMS_FULL_TXT = `${DOCS_BASE}/llms-full.txt`;
export const SITEMAP_XML = `${DOCS_BASE}/sitemap.xml`;
export const CHANGELOG_RSS = `${DOCS_BASE}/changelog/rss.xml`;
export const SEARCH_BUNDLE = `${DOCS_BASE}/pagefind/pagefind.js`;

/**
 * A link written in docs content or API data → the URL the site opens. Docs-root paths (the form
 * content and the changelog's `link` use: "/api-reference/platform/…") get the docs base; anchors,
 * other sites and mail stay as they are.
 */
export const resolveDocsHref = (href: string): { href: string; external: boolean } => {
  if (/^(https?:|mailto:)/.test(href)) return { href, external: true };
  if (href.startsWith("#")) return { href, external: false };
  if (href.startsWith("/")) return { href: siteUrl(href), external: false };

  return { href, external: false };
};
